module.exports = __webpack_public_path__ + "static/media/colicoli6.f5d1ae9e.webp";